import { usePetitionDetailsPageData, getTikTokPlayerUrl } from '#src/app/pages/petitionDetails/pageContext';
import { useMediaQuery } from '#src/app/shared/hooks/dom';
import { useCookiePrefAsync } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';

const DESKTOP_MEDIA_QUERY = '(min-width: 768px)';

export type VideoFirstViewport = 'desktop' | 'mobile';

type Result = ModelHookResult<{
	playerUrl: string | undefined;
	shouldRender: boolean;
	title: string;
	titleDataQa: string | undefined;
}>;

export function useVideoFirstHero(sourceUrl: string, viewport: VideoFirstViewport): Result {
	const marketingCookies = useCookiePrefAsync('marketing');
	const initialIsDesktop = typeof window !== 'undefined' && window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
	const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY, initialIsDesktop);
	const {
		data: {
			petition: { ask, displayTitle, photo },
		},
	} = usePetitionDetailsPageData();
	const playerUrl = getTikTokPlayerUrl(sourceUrl);
	const matchesViewport = viewport === (isDesktop ? 'desktop' : 'mobile');
	const hasPhoto = photo !== null;
	const title = hasPhoto ? displayTitle : ask;
	let titleDataQa: string | undefined;
	if (hasPhoto) {
		titleDataQa = viewport === 'desktop' ? 'petition-title-desktop' : 'petition-title-mobile';
	} else {
		titleDataQa = viewport === 'mobile' ? 'petition-title' : undefined;
	}

	return {
		data: {
			playerUrl,
			shouldRender: matchesViewport && isLoaded(marketingCookies) && marketingCookies.value && !!playerUrl,
			title,
			titleDataQa,
		},
	};
}
